import React, { Component } from 'react';
import { Link } from 'react-router';
import CSSModules from 'react-css-modules';

import FullWidthRegion from '../components/FullWidthRegion';
import Featured from '../components/Featured';
import Everything from '../components/Everything';
import ImageInfo from '../components/ImageInfo';
import Statement from '../components/Statement';
import Separator from '../components/Separator';

import currentlyShowing from '../../text/currentlyShowing.md';
import currentPress from '../../text/currentPress.md';
import content from '../../text/home.md';
import ukraine from '../../text/ukraine.md';

import styles from './HomePage.css';
import * as library from '../lib/library';

const MAX_WIDTH = 1100;

class HomePage extends Component {
  componentWillMount() {
    this.getAndSetWidth = this.getAndSetWidth.bind(this);
    window.addEventListener('resize', this.getAndSetWidth);
    this.getAndSetWidth();

    this.featured = [
      library.getSeriesById('constructed-narrative'),
      library.getSeriesById('symmetry'),
      library.getSeriesById('an-exercise-in-formal-composition'),
      library.getSeriesById('flowers-and-fabric'),
      library.getSeriesById('im-pretty-sure-this-is-exactly-right-series'),
      library.getSeriesById('fortune-cookies'),
    ];

    // Create an array of all work IDs found within all featured series objects.
    // TODO: Move this into library.js so it is cached.
    let ids = [];
    this.featured.forEach((series) => {
      ids = ids.concat(series.works);
    });

    // Grab a random work ID out of the compiled list, then get the full object:
    const primaryId = ids[Math.floor(Math.random() * ids.length)];
    this.primary = library.getWorkById(primaryId);


    // .map((item) => {
    //   // TODO: Get thumbnail URL for preview image:
    //   let src, worksInSeries, url;
    //
    //   worksInSeries = item.works.length
    //
    //   const firstWorkInSeries = library.getWorkById(item.works[0]);
    //   src = firstWorkInSeries.images[0].src
    //   url = `/works/${firstWorkInSeries.id}`;
    //
    //   return {
    //     src,
    //     url,
    //     id: item.id,
    //     title: item.title,
    //     count: worksInSeries
    //   };
    // });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getAndSetWidth);
  }

  getAndSetWidth() {
    const clientWidth = document.body.clientWidth;
    const width = Math.min(MAX_WIDTH, clientWidth);
    this.setState({ width });
  }

  render() {
    document.title = 'Jennifer Zwick';

    // const primary = library.getWorkById('flowers-and-fabric-2');
    const primary = this.primary;

    return (
      <div>
        <div styleName="hero-wrapper">
          <div styleName="hero" style={{ backgroundImage: `url(${primary.images[0].src})` }}>
            <h1>Jennifer Zwick</h1>
          </div>
          <ImageInfo href={`/works/${primary.id}`} labelText={primary.title} />
        </div>

        <div styleName="intro-wrapper">
          <FullWidthRegion>
          <nav>
            <ul styleName="nav">
              <li><Link to="/resume">Resume</Link></li>
              <li><Link to="/press">Press</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>
          <Separator />
          <Statement text={content} />
          </FullWidthRegion>
          <Separator />
          <div styleName="announcement">
            <Statement text={currentlyShowing} noColumns />
          </div>
        </div>

        <div styleName="separator-wrapper">
          <FullWidthRegion>
            <Separator />
          </FullWidthRegion>
        </div>

        <Featured />
        <Everything />
      </div>
    );
  }
}

export default CSSModules(HomePage, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/pages/HomePage.js